var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('img',{attrs:{"src":_vm.posterUrl,"alt":""}}),_c('div',{staticClass:"cost",on:{"click":_vm.getBaseInfos}},[_vm._v("授权登录")])])
}
var staticRenderFns = []

export { render, staticRenderFns }